import { RootState } from '../../model/model'
import { VAScale } from '../../model/vaScales'

export const selectVaScaleCatalog =
	(scale: VAScale) =>
	(state: RootState): string[] => {
		return [
			...new Set(
				state.vaScales.scales
					.map(s => s[scale])
					.filter(s => s !== undefined || s !== null)
					.map(val =>
						typeof val === 'string' && val.includes(',')
							? val.replace(',', '.')
							: val,
					)
					.sort((a: string, b: string) => {
						const _a = Number(a)
						const _b = Number(b)

						if (isNaN(_a) && isNaN(_b)) return _a - _b
						else if (isNaN(_a) && !isNaN(_b)) return 1
						else if (!isNaN(_a) && isNaN(_b)) return -1
						else return _a - _b
					}) || [],
			),
		]
	}

export const selectVaScaleCatalogAsOptions =
	(scale: VAScale) =>
	(state: RootState): { label: string; value: string }[] => {
		const opts = selectVaScaleCatalog(scale)(state)
		return opts.map(e => ({ label: e, value: e }))
	}
